import { RenovationExecutor } from 'shared/constants/space-renovation-requests';

import type { ExecutorProps } from './RenovationTypes.type';

import RenovationExecutorOrganization from './RenovationExecutorOrganization';
import RenovationExecutorPerson from './RenovationExecutorPerson';
import RenovationExecutorPortalUser from './RenovationExecutorPortalUser';
import RenovationExecutorForeignCompany from './RenovationExecutorForeignCompany';

const renovationExecutorFactory =
  (type: RenovationExecutor | null) => (props: ExecutorProps) => {
    switch (type) {
      case RenovationExecutor.Organization:
        return <RenovationExecutorOrganization {...props} />;
      case RenovationExecutor.ForeignCompany:
        return <RenovationExecutorForeignCompany {...props} />;
      case RenovationExecutor.Person:
        return <RenovationExecutorPerson {...props} />;
      case RenovationExecutor.PortalUser:
        return <RenovationExecutorPortalUser {...props} />;
      default:
        return null;
    }
  };

export default renovationExecutorFactory;
